import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueGtag from 'vue-gtag'
import firebaseConfig from './config/firebase'
import firebase from 'firebase'
import 'firebase/firestore'

Vue.config.productionTip = false

const options = {
  config: {
    id: 'G-4QLN5DL21X' // replace GA_MEASUREMENT_ID with your ID
  }
}

Vue.use(VueGtag, options, router)

const firebaseApp = firebase.initializeApp(firebaseConfig)
const db = firebaseApp.firestore()
Vue.$db = db

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
